import { FC } from 'react'
import { PlanPurchaseExperienceDialog } from '@app/common/src/components/PlanPurchaseExperienceDialog'
import { useProUpgradeModalContainerState } from './ProUpgradeModal.hooks'

export interface ProUpgradeModalProps {
  modalOpen: boolean
  onClose: () => void
}

export const ProUpgradeModal: FC<ProUpgradeModalProps> = ({ modalOpen, onClose }) => {
  const { onPaymentSuccess, handleClose, planTypeUpgradingTo } = useProUpgradeModalContainerState({
    onClose
  })

  return (
    <>
      <PlanPurchaseExperienceDialog
        open={modalOpen}
        onClose={handleClose}
        planType={planTypeUpgradingTo}
        onSuccessfulCheckout={onPaymentSuccess}
      />
    </>
  )
}
